module.exports = __webpack_public_path__ + "img/5f32e3d.jpg";